import React, {useEffect, useState, lazy} from "react";
import Actions from "../../components/Tables/Actions/Actions";
import {Link} from "react-router-dom";
import url from "../../utils/UrlHelper";
import {useAppSelector} from "../../redux/hooks";
import marketService from "../../api/services/marketService";
const FormBarcode = lazy(() => import("../../components/Barcode/FormBarcode"))

const BarcodePage: React.FC = () => {
    const { sellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    const [wildMarketId, setWildMarketId] = useState<string>('');
    const [sberMarketId, setSberMarketId] = useState<string>('');
    const [yandexMarketId, setYandexMarketId] = useState<string>('');

    function getKeyByValue(object: any, value: any) {
        return Object.keys(object).find(key => object[key] === value);
    }

    useEffect(() => {
        marketService.getMarkets().then((res) => {
            if (Object.values(res.data).length > 0) {

                const wildMarketId: any = getKeyByValue(res.data.data,"WildBerries");
                const sberMarketId: any = getKeyByValue(res.data.data,"Мегамаркет");
                const yandexMarketId: any = getKeyByValue(res.data.data,"Яндекс.Маркет");

                if(wildMarketId) {
                    setWildMarketId(wildMarketId)
                }

                if(sberMarketId) {
                    setSberMarketId(sberMarketId)
                }

                if(yandexMarketId) {
                    setYandexMarketId(yandexMarketId)
                }
            }
        }).catch(err => {
            console.log(err)
        })
    },[])

    return (
        <div className="p-4">
            <div className="flex flex-col md:flex-row justify-between">
                <div className="mt-4 md:mt-0 w-full max-w-full overflow-hidden">
                    {/*Actions start*/}
                    <Actions>
                        <div>
                            {/*Tabs start*/}
                            <ul className="style_tabList__2eNFD contact-list" >
                                <li className="pb-[8px] pr-[20px] mr-4 pb-[8px] text-[#64748B] style_tabLink" aria-selected="true">
                                    Генератор ШК
                                </li>
                                <li className="pb-[8px]">
                                    <Link className="pr-[20px] mr-4 pb-[8px] text-[#64748B] hover:text-[#1f55a1]" to={url('/:sellerId/tools', sellerId)}>YML Feed</Link>
                                </li>
                            </ul>
                            {/*Tabs end*/}
                        </div>
                    </Actions>
                    {/*Actions end*/}

                    <div className={'flex'}>
                        <div className="w-full p-2">
                            <FormBarcode
                                wbMarketId={wildMarketId}
                                sberMarketId={sberMarketId}
                                yandexMarketId={yandexMarketId}
                            ></FormBarcode>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BarcodePage
